/**
 * The string an unauthenticated call fails with. The server throws it as the
 * `appCode` of an UNAUTHENTICATED error and the client matches on it to send
 * the person to the sign-in page.
 */
export const unauthenticatedError = 'Unauthenticated';
